import React from "react";
import { styled } from "@mui/material";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";

import commonImage from "../assets/icons/experienceSectionGirlImage.png"; 

const Container = styled("div")`
  display: flex;
  align-items: center;
  padding: 0vw 5vw 0vw;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 5vw 5vw 0vw;
  }
  @media (max-width: 375px) {
    ${'' /* padding: 5vw 0vw 0vw; */}
  }
`;

const TextWrapper = styled("div")`
  width: 50%;
  font-size: 2.625rem;/*42px */
  font-weight: 500;
  color: #231f20;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  @media (max-width: 1280px) {
    font-size: 2rem;

  }

  @media (max-width: 768px) {
    width: 100%;
    font-size: 1.313rem;/*21px */
    align-items: flex-end;
    text-align: center;
    order: 1;
    margin-bottom: 3vw;
  }
`;

const ImageWrapper = styled("div")`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: -5vw;
  @media (max-width: 768px) {
    order: 2;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: -20vw;
    width: 100%;
  }
`;

const StyledImage = styled("img")`
  width: 70%;
  ${'' /* max-width: 350px; */}

  @media (max-width: 768px) {
    width: 70%;
  }
  @media (max-width: 475px) {
    width: 60%;
  }
  @media (max-width: 425px) {
    width: 55%;
  }
  @media (max-width: 375px) {
    width: 45%;
  }
`;

const ButtonWrapper = styled("div")`
  display: flex;
  align-items: center; 
  gap: 1rem; 
  @media (max-width: 768px) {
    flex-direction: column; 
    align-items: center;
    gap: 0.5rem;
  }
`;

const StyledText = styled("span")`
  line-height: 50px;
  font-size: 2.625rem;/*42px */
  font-weight: 500;
  color: #231f20;
  display: inline-block;
  margin-bottom: -30px; 
  @media (max-width: 1280px) {
    font-size: 2rem;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 0;
    font-size: 1.313rem;/*21px */
  }
`;


const ExperienceSection = () => {
    const location = useLocation(); 
  
    const isBackgroundChecks = location.pathname.includes("background-checks");
    const isDueDiligence = location.pathname.includes("due-diligence");
    const isInstantChecks = location.pathname.includes("instant-checks");
  
    return (
      <Container>
        <ImageWrapper>
          <StyledImage src={commonImage} alt="Experience Section" />
        </ImageWrapper>
        <TextWrapper>
          {isBackgroundChecks && (
            <>
              Customize your screening package with expert guidance-
              <br />
              book a free consultation today!
            </>
          )}
          {isDueDiligence && (
            <>
              Customize your risk model and parameters with expert guidance-
              <br />
              book a free consultation today!
            </>
          )}
          {isInstantChecks && (
            <>
              Ready to experience <br/> the future of instant checks?
            </>
          )}
          <ButtonWrapper>
          <Button className="custom-button experience-button" variant="contained">
            Book an appointment
          </Button>
          {isInstantChecks && <StyledText>Today!</StyledText>} 
        </ButtonWrapper>
        
        </TextWrapper>
      </Container>
    );
  };
  
  export default ExperienceSection;
  